export default __webpack_public_path__ + "static/media/top-ten-block-6.3b68a377.svg";